//src/components/GoldFileDownloadButton.tsx
import React, { useState } from 'react';
import { Download } from 'lucide-react';
import { Button } from './Button';
import { supabase } from '../lib/supabase';

export function GoldFileDownloadButton() {
  const [isDownloading, setIsDownloading] = useState(false);

  const handleDownload = async () => {
    try {
      setIsDownloading(true);
      const { data: { session } } = await supabase.auth.getSession();
      if (!session?.access_token) throw new Error('Not authenticated');

      const response = await fetch('https://cdnbjnapvlbmarhuflsv.supabase.co/functions/v1/generate_combined_gold_file', {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${session.access_token}`,
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) throw new Error('Failed to fetch Golden File');
      const data = await response.json();
      const fullName = session.user.user_metadata?.name || 'User';

      const blob = new Blob([data.textContent || ''], { type: 'text/plain' });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `Gold File - ${fullName}.txt`;
      link.click();
      URL.revokeObjectURL(url);
    } catch (err) {
      console.error('Download error:', err);
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <Button
      variant="outline"
      onClick={handleDownload}
      disabled={isDownloading}
      className="w-full flex items-center justify-center gap-2 mt-4"
    >
      <Download className="w-4 h-4" />
      {isDownloading ? 'Downloading...' : 'Download My Gold File'}
    </Button>
  );
}
